export default {
      id: "arrow-special-right-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "sprite.svg#arrow-special-right",
      toString: function () {
        return this.url;
      }
    }


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/arrow-special-right.svg
// module id = 129
// module chunks = 241 242 243